import { render, staticRenderFns } from "./error.vue?vue&type=template&id=ce62f016&scoped=true&"
import script from "./error.vue?vue&type=script&lang=js&"
export * from "./error.vue?vue&type=script&lang=js&"
import style0 from "./error.vue?vue&type=style&index=0&id=ce62f016&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce62f016",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Footer: require('/app/components/partials/Footer.vue').default})
